module.exports = __webpack_public_path__ + "media/images/icon__point--gained@2x-6125ca5245d8f39a6e904314d0fd3cdd.png";